import React from "react";
import Text from "antd/lib/typography/Text";
import { Checkbox, Divider } from "antd";
import { ServiceOption } from "@/lib/api/types";

interface OptionCheckBoxProps {
  showPrice?: boolean;
  option?: ServiceOption;
  onCancelOption: () => void;
  onOpenOptionModal: () => void;
}
const OptionCheckBox = ({
  showPrice,
  option,
  onOpenOptionModal,
}: OptionCheckBoxProps) => {
  return (
    <>
      {option ? (
        <Checkbox checked={true} onChange={onOpenOptionModal}>
          <Text strong>Option:</Text>{" "}
          <Text className="is-size-7">
            {option.title}
            {showPrice && (
              <>
                <Divider type="vertical" />${option.price}
              </>
            )}
          </Text>
        </Checkbox>
      ) : (
        <Checkbox onChange={onOpenOptionModal}>
          Do you need more specific options?
        </Checkbox>
      )}
    </>
  );
};

export default OptionCheckBox;
